import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Заявка с този флаг казва на `errorInterceptor`: „екранът казва причината на
 * отказа сам“. Общият тостер тогава мълчи, а грешката пак стига до извикващия
 * — иначе един отказ излиза с два тоста (#403).
 *
 * Слагай го само там, където екранът показва собствено съобщение за всеки
 * провал на заявката, включително неизвестния. 401 се обработва от
 * `authInterceptor` независимо от флага.
 */
export const HANDLES_OWN_ERRORS = new HttpContextToken<boolean>(() => false);

/** Контекст за заявка, чиито грешки екранът обработва сам (виж `HANDLES_OWN_ERRORS`). */
export function handlesOwnErrors(): HttpContext {
  return new HttpContext().set(HANDLES_OWN_ERRORS, true);
}
